import React from "react";
import styles from "./Inputfield.module.css";

function InputField({ label, fieldRef, name, type, id }) {
  return (
    <article>
      <label htmlFor={id}>{label}</label>
      <input
        className={styles["input-field"]}
        {...fieldRef}
        name={name}
        type={type}
        id={id}
        autoComplete="on"
      />
    </article>
  );
}

export default InputField;
